import type { I18n } from "@lingui/core";
import { Trans, useLingui } from "@lingui/react";
import type { MobilityAd } from "@mobility-item-page/types";
import { Button } from "@warp-ds/react";
import { useAppConfig } from "../../context/AppConfigProviderContext.tsx";

type Props = {
  adViewType: MobilityAd["adViewType"];
  className?: string;
};

const ContactAdvertiser = ({ adViewType, className = "" }: Props) => {
  const { isPreview } = useAppConfig();
  const { i18n } = useLingui();
  const description = getContactDescription(adViewType, i18n);

  return (
    <section className={`${description ? "border rounded-8 relative p-16" : ""}  ${className}`}>
      <h2 className="sr-only">
        {i18n.t({
          id: "itemPageLayout.contactAdvertiser.heading",
          message: "Contact advertiser",
          comment: "Screen-reader-only heading for the contact section",
        })}
      </h2>
      {description && <p className="mb-0"> {description} </p>}
      <div className="mt-16">
        {!isPreview ? (
          // @ts-expect-error TODO: fix this
          <finn-contact-button></finn-contact-button>
        ) : (
          <Button primary fullWidth>
            <Trans id="itemPageLayout.contactButton.preview" message="Send message" />
          </Button>
        )}
      </div>
    </section>
  );
};

export default ContactAdvertiser;

const getContactDescription = (adViewType: MobilityAd["adViewType"], i18n: I18n): string | null => {
  switch (adViewType) {
    case "car-used":
    case "car-leasing": {
      return i18n.t({
        id: "itemPageLayout.contactAdvertiser.car.text",
        message: "Get more information about the car or schedule a test drive.",
        comment: "For car only",
      });
    }
    case "a-tractor":
    case "motorcycle":
    case "moped":
    case "atv":
    case "snowmobile":
    case "caravan":
    case "mobile-home":
    case "agriculture-thresher":
    case "agriculture-tractor":
      return i18n.t({
        id: "itemPageLayout.contactAdvertiser.vehicle.text",
        message: "Get more information about the vehicle or schedule a test drive.",
        comment: "A more general text for all vehicles",
      });
    default:
      return null;
  }
};
